'use strict';

import { exists, assignStyling, documentReady } from 'Util/util';
import * as debounce from 'lodash/debounce';

/**
 * @private checkFooterOverlapping
 */
function checkFooterOverlapping() {
    const footerContainer = document.querySelector('.js-vz-footer');
    const fourOhFourAbsoluteContainer = document.querySelector('#js-404-page-absolute-container');

    if (exists(footerContainer) && exists(fourOhFourAbsoluteContainer)) {
        footerContainer.classList.add('mt-5');
        footerContainer.style.removeProperty('margin-top');

        const footerContainerRect = footerContainer.getBoundingClientRect();
        const fourOhFourAbsoluteContainerRect = fourOhFourAbsoluteContainer.getBoundingClientRect();

        if (fourOhFourAbsoluteContainerRect.bottom >= footerContainerRect.top) {
            footerContainer.classList.remove('mt-5');

            assignStyling(footerContainer, {
                'margin-top': `${fourOhFourAbsoluteContainerRect.bottom - footerContainerRect.top + 10}px`
            });
        }
    }
}

documentReady(checkFooterOverlapping);
window.addEventListener(
    'resize',
    debounce(() => {
        checkFooterOverlapping();
    }),
    150
);
